export default __webpack_public_path__ + "static/e-health_logo-f38750db31a4154c0bfcdb1ab91af1aa.png";